<div class="area_utente" *ngIf="showUserHeader && userInfo">
    <div class="container-fluid">
      <div class="row">
        <div class="user_info">
          <mat-icon>person</mat-icon>
          <span>{{userInfo.cognome}} {{userInfo.nome}} {{userInfo.codiceFiscale}}</span>
        </div>
        <div id="emailAssistenza" (click)="openMsgDialog()">
          <mat-icon> email</mat-icon>
        </div>
        <!-- <div class="profili_info">
          <a class="buttonBreadcrumb" routerLink="/landing">
           <mat-icon>undo</mat-icon>
            Profili
          </a>
        </div> -->
        <div class="logout_button" (click)="logout()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Logout</span>

        </div>
      </div>
    </div>
  </div>
